// src/navConfig.js

const navConfig = {

    // ai: {
    //     base: '/ai',
    //     name: 'AI',
    //     links: [
    //         { to: '/ai/us-top-gainers-with-ai', name: '미국 상승주 AI 분석' },
    //         { to: '/ai/us-top-losers-with-ai', name: '미국 하락주 AI 분석' },
    //         { to: '/ai/krx-top-gainers-with-ai', name: '한국 상승주 AI 분석' },
    //     ],
    // },
    backtest: {
        base: '/backtest',
        name: '백테스팅',
        links: [
            { to: '/backtest/strategy-oecd-cli', name: 'CLI 기반 롱 전략' },
            { to: '/backtest/strategy-inverse-oecd-cli', name: 'CLI 기반 숏 전략' },
            { to: '/backtest/strategy-oecd-cli-di', name: 'CLI 확산 지수' },
            { to: '/backtest/backtest-11to4', name: '11to4 전략' },
            { to: '/backtest/backtest-lazy-portfolio', name: '정적 자산배분' },
        ],
    },

    stock: {
        base: '/kr-trade',
        name: '수출 데이터 한눈에',
        links: [
            { to : '/kr-trade/export-summary-now', name: '수출 NOW' },
            { to : '/kr-trade/export-summary', name: '과거 연도별 수출' },
            { to: '/kr-trade/stock-vs-export', name: '주가 vs 품목별 수출' },
            { to : '/kr-trade/export-summary-now_regional', name: '지역별 수출 NOW' },
            { to : '/kr-trade/export-summary-regional', name: '과거 연도별 지역별 수출' },
            { to: '/kr-trade/export-by-region', name: '지역별 품목별 수출 그래프' },
        ],
    },
    market: {
        base: '/krx-market',
        name: '한국 시장',
        links: [
            { to: '/krx-market/krx-idx-vs-trade', name: '주가지수 vs 수출' },
            { to: '/krx-market/valuation', name: '주가지수 밴드' },
            { to: '/krx-market/earnings', name: '주가지수 vs 어닝' },
            // { to: '/krx-market/stock-vs-earning', name: '주가 vs 어닝' },
        ],
    },
    global: {
        base: '/global',
        name: '글로벌 시장',
        links: [
            { to: '/global/global-market-performance', name: '글로벌 주식시장 성과' },
            { to: '/global/all-asset-performance', name: '자산별 성과' },
            { to: '/global/gold_demand_trends', name: '금 수요 트렌드'}
        ],
    },
    notice: {
        base: '/notice',
        name: '공지',
        links: [
            { to: '/notice/about', name: 'About' },
            { to: '/notice/updates', name: '업데이트 일정' },
        ],
    },
};

// Node.js의 require와 React의 import 모두에서 작동하도록 module.exports를 사용합니다.
module.exports = { navConfig };